<template>
  <div class="row">

    <div class="col-xs-12">
      <h1 class="m-b-20 mt-0">Samarbejder</h1>
    </div>

    <div class="col-xs-12">
      Hos {{ trans('global.system_name') }} er vi hele tiden på udkig efter at udvide vores system, så vi kan understøtte jeres behov
      for at arbejde med både private og offentlige institutioner.
      <br><br>
      Derfor vil vi gerne høre om der er en specifik instans, som i gerne vil have at {{ trans('global.system_name') }} samarbejder
      med. Du kan klikke på mulighederne nedenfor. Vælg gerne mere end en.
    </div>

    <div class="text-center" v-if="loading">
      <div class="preloader"></div>
    </div>

    <div class="col-xs-12 m-t-20" v-if="answered">
      <ep-banner variant="success">Tak for dit svar.</ep-banner>
    </div>

    <form method="POST" v-on:submit.prevent="send()" v-else-if="!loading">
      <div class="col-xs-12 m-t-20">
        <div class="well online-booking-flow-choices">

          <div class="big-radio-choice flex m-b-10 cursor-pointer card-box p-10"
               :class="{'selected' : tryg}" v-on:click="tryg = !tryg">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
              <i class="zmdi" :class="tryg ? 'zmdi-check-circle' : 'zmdi-circle-o'"></i>
            </div>
            <div for="client_access_type_none" class="big-radio-description mb-auto mt-auto">
              <h4 class="m-0 m-b-5">Tryg </h4>
              <small class="text-muted block">Modtag aftaler fra Tryg Behandlerbooking i Terapeut
                Booking</small>
            </div>
          </div>

          <div class="big-radio-choice flex m-b-10 cursor-pointer card-box p-10"
               :class="{'selected' : pension}" v-on:click="pension = !pension">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
              <i class="zmdi" :class="pension ? 'zmdi-check-circle' : 'zmdi-circle-o'"></i>
            </div>
            <div for="client_access_type_none" class="big-radio-description mb-auto mt-auto">
              <h4 class="m-0 m-b-5">Pension Danmark </h4>
              <small class="text-muted block">Modtag aftaler fra Pension Danmark Behandlerbooking i Terapeut
                Booking</small>
            </div>
          </div>

          <div class="big-radio-choice flex m-b-10 cursor-pointer card-box p-10"
               :class="{'selected' : medcom}" v-on:click="medcom = !medcom">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
              <i class="zmdi" :class="medcom ? 'zmdi-check-circle' : 'zmdi-circle-o'"></i>
            </div>
            <div for="client_access_type_none" class="big-radio-description mb-auto mt-auto">
              <h4 class="m-0 m-b-5">Medcom</h4>
              <small class="text-muted block">
                Kommunikation med læger, sygehuse og kommuner via {{ trans('global.system_name') }}
              </small>
            </div>
          </div>


          <div class="big-radio-choice flex m-b-10 cursor-pointer card-box p-10"
               :class="{'selected' : other}" v-on:click="other = !other">
            <div class="big-radio-form-control m-r-15 mb-auto mt-auto">
              <i class="zmdi" :class="other ? 'zmdi-check-circle' : 'zmdi-circle-o'"></i>
            </div>
            <div for="client_access_type_none" class="big-radio-description mb-auto mt-auto">
              <h4>Andet...</h4>
              <input type="text" class="form-control" placeholder="Angiv dit svar her" v-model="which_other"
                     v-show="other" v-on:click.stop>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-6">
              <button type="button" class="btn btn-default btn-block truncate btn-lg m-b-10" v-on:click="selectNone()">
                <i class="zmdi zmdi-close m-r-5"></i> Jeg har ikke brug for noget pt.
              </button>
            </div>
            <div class="col-xs-12 col-sm-6">
              <button type="submit" class="btn btn-custom btn-block truncate btn-lg" :disabled="is_disabled">
                Indsend svar <i class="zmdi zmdi-arrow-right m-l-5"></i>
              </button>
            </div>
          </div>


        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {http} from '../../http';

export default {
  name: "DanishSystemsSurvey",

  data() {
    return {
      tryg: false,
      pension: false,
      medcom: false,
      other: false,
      which_other: '',
      none: false,
      answered: false,
      loading: true
    };
  },

  mounted() {
    http.get('survey/danish-systems-survey')
        .then(({data}) => {
          this.loading = false;
          if (data.response) {
            this.answered = true;
          }
        });
  },

  computed: {
    is_disabled() {
      return !this.tryg && !this.pension && !this.medcom && !this.other;
    }
  },

  methods: {
    send() {
      http.post('/app/survey/danish-systems-survey', {
        tryg: this.tryg,
        pension: this.pension,
        medcom: this.medcom,
        other: this.other,
        which_other: this.which_other,
        none: this.none,
      }).then(({data}) => {
        this.answered = true
      });
    },

    selectNone() {
      this.tryg = false;
      this.pension = false;
      this.medcom = false;
      this.other = false;
      this.which_other = '';
      this.none = true;
      this.send();
    }
  }
}
</script>

<style scoped>

</style>
